/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

const DisclaimerText = styled.div`
  color: #333333;
`;

const Disclaimer = () => {
  return (
    <DisclaimerText>
      This is a publicly-available directory of travel policies and travel restrictions currently in place due to the
      COVID pandemic. Our goal is to gather in one place information about countries, U.S. states, airlines, hotels, and
      car rental companies.
      <br />
      <br />
      We want to be as accurate and timely as possible and sincerely apologize if we get anything wrong. Don&apos;t
      hesitate to double-check our advice with a quick Google search, and reach out to Elliott (
      <a href="mailto:elliottm@amtrav.com">elliottm@amtrav.com</a>) if you spot a mistake.
    </DisclaimerText>
  );
};

export default Disclaimer;
